<template>
  <div>
    <common-list
      ref="list"
      url="MaterialExitRecords/GetList"
      :init="filter"
      @currentrow="handlerCurrentRow"
    >
      <!-- 条件区域 -->
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
          <el-form-item label="仓库名称" prop="WarehouseId">
            <RemoteSelect
              v-model="filter.WarehouseId"
              url="AccessoryEntryRecords/GetWareHouseList?WarehouseType=1"
              code="WarehouseId"
              name="WarehouseName"
              placeholder="选择仓库"
            >
            </RemoteSelect>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="物料名称">
            <CascaderSelect v-model="filter.ScrapId"></CascaderSelect>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="开始日期">
            <el-date-picker
              v-model="filter.begin"
              type="date"
              placeholder="开始日期"
              @input="
                (time) => {
                  Time.begin = time;
                }
              "
              :picker-options="start_date"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结束日期">
            <el-date-picker
              v-model="filter.end"
              type="date"
              placeholder="结束日期"
              @input="
                (time) => {
                  Time.end = time;
                }
              "
              :picker-options="end_date"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="来源">
            <el-input
              v-model.trim="filter.Source"
              placeholder="来源"
              clearable
            ></el-input>
          </el-form-item>
        </el-col> -->
      </template>
      <!-- 按钮区域 -->
      <template v-slot:option> </template>
      <!-- 展示区域 -->
      <template v-slot:body>
        <el-table-column
          label="出库编号"
          prop="ExitId"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="物料名称" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.MaterialName | gang }}
          </template></el-table-column
        >
        <el-table-column label="重量" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.Weight | gang }}
          </template></el-table-column
        >
        <el-table-column label="单位" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.Unit }}
          </template></el-table-column
        >
        <el-table-column label="入场编号" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.Source }}
          </template></el-table-column
        >
        <el-table-column label="仓库" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.WarehouseName }}
          </template></el-table-column
        >
        <!-- <el-table-column label="批次" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.BatchId | gang }}
          </template></el-table-column
        > -->
        <el-table-column label="出库人员" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.Operator }}
          </template></el-table-column
        >
        <el-table-column label="出库时间" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.OperationDate | datetime("YYYY-MM-DD") }}
          </template></el-table-column
        >
      </template>
    </common-list>
    <!-- 弹窗区域 Show -->
    <div>
      <AddEdit :item="itemAddEdit" @success="getData"></AddEdit>
      <Showdialog :item="itemShow"></Showdialog>
    </div>
  </div>
</template>
  
  <script>
import AddEdit from "./AddEdit";
import Showdialog from "./Show";
export default {
  components: {
    AddEdit,
    Showdialog,
  },
  data() {
    let today = this.$dayjs().format("YYYY-MM-DD");
    return {
      itemAddEdit: {},
      itemShow: {},
      showitem: [],
      filter: {
        begin: today,
        end: today,
      },
      Time: {
        begin: today,
        end: today,
      },
      start_date: {
        //开始时间范围限定
        disabledDate: (time) => {
          if (this.Time.end) {
            return (
              time.getTime() > Date.now() || time.getTime() > this.Time.end
            );
          }
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", today);
            },
          },
        ],
      },
      end_date: {
        //结束时间范围限定
        disabledDate: (time) => {
          return (
            time.getTime() >= Date.now() ||
            time.getTime() <= this.Time.begin - 8.64e7
          );
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", today);
            },
          },
        ],
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    add() {
      this.itemAddEdit = {};
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemAddEdit = { EntryId: this.currentrow.EntryId };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `将删除编号为【${this.currentrow.EntyId}】的仓库信息, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("WareHouse/Delete", {
            WarehouseId: this.currentrow.WarehouseId,
          }).then(() => {
            this.$message.success("删除成功");
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
    show() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemShow = { EntryId: this.currentrow.EntryId };
    },
  },
};
</script>
  
  <style>
</style>